import { LoadingSpinner } from "../core/components/LoadingSpinner";
import { useLogoutMutation, useMeQuery } from 'legoland-sdk/dist/experimental';
import { useEffect, useState } from 'react';
import { useRedirectQsParam } from "./useRedirectQsParam";
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoutPage = () => {
  const meQuery = useMeQuery();
  const logoutMutation = useLogoutMutation();
  const {
    url: redirectUrl
  } = useRedirectQsParam();
  const [shouldLogout, setShouldLogout] = useState(false);
  const redirect = () => window.location.replace(redirectUrl ?? `/login`);
  useEffect(() => {
    if (meQuery.isLoading) {
      return;
    }
    if (meQuery.isError) {
      throw meQuery.error;
    }
    if (!meQuery.data.me) {
      redirect();
      return;
    }
    setShouldLogout(true);
  }, [meQuery]);
  useEffect(() => {
    if (shouldLogout) {
      // setTimeout is a workaround to execute logout after refresh-token
      setTimeout(() => logoutMutation.mutate(undefined, {
        onSuccess: redirect
      }));
    }
  }, [shouldLogout]);
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    "data-sentry-element": "LoadingSpinner",
    "data-sentry-component": "LogoutPage",
    "data-sentry-source-file": "LogoutPage.tsx"
  });
};